/* ---------- 11. nav scroll (Webflow IX3) ---------- */

const NAV = { top: 80, threshold: 8 }; // px: "near top" always shows main nav; min scroll delta to count as a direction

/** Scrolling down past the top → "nav-scroll-down" (event nav); scrolling up or near the top → "nav-scroll-up" (main nav). */
export const navScroll = () => {
  const ix = window.Webflow?.require?.('ix3');
  if (!ix) throw new Error('IX3 unavailable'); // same outcome as before: logged by run(), no events
  let prev = window.scrollY;
  let state = 'main';
  let ticking = false;
  const set = (next: string, event: string) => {
    if (state !== next) {
      state = next;
      ix.emit(event);
    }
  };
  const update = () => {
    const y = window.scrollY;
    const delta = y - prev;
    if (y <= NAV.top) set('main', 'nav-scroll-up');
    else if (Math.abs(delta) >= NAV.threshold) {
      if (delta > 0) set('event', 'nav-scroll-down');
      else set('main', 'nav-scroll-up');
    }
    prev = y;
    ticking = false;
  };
  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true },
  );
};
